module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('audio', {
    attrs: {
      "id": "ding",
      "src": _vm.assetsUrl + '/ding.mp3'
    }
  }), _c('audio', {
    attrs: {
      "id": "start",
      "src": _vm.assetsUrl + '/send_start.mp3'
    }
  }), _c('audio', {
    attrs: {
      "id": "error",
      "src": _vm.assetsUrl + '/send_error.mp3'
    }
  }), _c('audio', {
    attrs: {
      "id": "success",
      "src": _vm.assetsUrl + '/send_success.mp3'
    }
  }), (_vm.messenger) ? _c('article', {
    style: ({
      backgroundColor: _vm.messenger.appearance.primary_color
    })
  }, [_c('header', [_c('div', {
    staticClass: "offset"
  }, [_c('avatar', {
    attrs: {
      "person": _vm.messenger.greeter,
      "borderColor": _vm.messenger.appearance.primary_color
    }
  }), _c('div', {
    staticClass: "name"
  }, [_c('h2', [_vm._v(_vm._s(_vm.messenger.greeter.name))])])], 1)]), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e59b081","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 123
// module chunks = 1